import { getFirebaseAuthToken } from './getFirebaseAuthToken';

/**
 * Relay de eventos de ciclo de vida para o backend (-> workflow WhatsWave -> listas + CRM).
 *
 * Complementa o GTM/Pixel (que continuam sendo enviados normalmente): só chama o backend
 * para eventos que apenas o navegador conhece (checkout.started, campaign.landing).
 * Falha silenciosa: tracking nunca pode quebrar a navegação.
 *
 * Identificação: ID token Firebase (usuário logado) ou `ref` (UUID do contato WhatsWave
 * no final da URL do botão do template).
 */

const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
];

export function pickAttribution(params = {}) {
  const out = {};
  ATTRIBUTION_KEYS.forEach((key) => {
    if (params && typeof params[key] === 'string' && params[key]) out[key] = params[key];
  });
  return out;
}

export async function sendLifecycleEvent(event, payload = {}) {
  try {
    const apiUrl = process.env.REACT_APP_SERVICE_API || 'http://localhost:3200';
    const headers = { 'Content-Type': 'application/json' };
    const token = await getFirebaseAuthToken();
    // Visitante anônimo sem `ref` não pode ser identificado: nada a registrar no CRM.
    if (!token && !payload.ref) return;
    if (token) headers.Authorization = `Bearer ${token}`;

    await fetch(`${apiUrl}/api/events/track`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ event, ...payload }),
      keepalive: true,
    });
  } catch {
    // ignore
  }
}
